import { deepMergeResources, sharedResources } from '@flexibilitypay/shared';
import type { Resource, ResourceLanguage } from 'i18next';
import { appResources } from './resources/es-AR';

const merged = deepMergeResources(
  sharedResources['es-AR'] as Record<string, unknown>,
  appResources['es-AR'] as Record<string, unknown>,
);

export const resources: Resource = { 'es-AR': merged as ResourceLanguage };
